import PageIntro from "../../Components/modern/PageIntro";
import { Container, SectionHeading } from "../../Components/modern/UI";

export default function Events() {
  return (
    <>
      <PageIntro eyebrow="Events" title={<>Upcoming Events</>}>
        Updates will be added here when confirmed event details are available.
      </PageIntro>

      <section aria-labelledby="sn-events-empty" className="sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-8 sn-text-center sn-shadow-soft md:sn-p-12">
            <SectionHeading eyebrow="Events" id="sn-events-empty">Upcoming Events</SectionHeading>
            <p className="sn-mx-auto sn-mt-5 sn-max-w-xl sn-text-base sn-leading-relaxed sn-text-muted">
              Event updates will be published here once the Suryanirbhar team confirms dates, locations and photographs.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
}
